// extracted by mini-css-extract-plugin
module.exports = {"landing_page_DPTSB":"DPTSB_landing_page_DPTSB__d83gO"};